import { AmountValue } from 'common/interfaces';
import { TargetsData } from 'stores/workflowStores/finances/targets/model';
import { ReservesData } from 'stores/workflowStores/finances/newReservesStore/model';
import { DepositsData } from 'stores/workflowStores/finances/depositsStore/model';
import { Currency } from 'enums';

export const initialValues: Withdrawal = {
  standardFlow: true,
  withdrawAll: false,
  closeAccount: false,
  selectedBankAccount: '',
  amount: {
    value: 0,
    currency: Currency.NONE
  },
};

export interface Withdrawal {
  standardFlow: boolean;
  withdrawAll: boolean;
  closeAccount: boolean;
  selectedBankAccount: string;
  amount: AmountValue;
  ltipAllowed?: boolean;
  minStart?: string;
  options?: {
    bankAccountOptions: {
      id: string;
      number: string; // funny
    }[];
  };
}

export interface ReservesAndTargets {
  targetData: TargetsData;
  reserveData: ReservesData;
  depositData: DepositsData;
  options: { defaultInflationRate: number; defaultInflationType: string; };
}
